module.exports = __webpack_public_path__ + "static/media/sub.5c3f92f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage_new/images/work/sub.png
// module id = 2698
// module chunks = 0